var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColourWhiteSize20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8 3.6H5.2C4.31634 3.6 3.6 4.31634 3.6 5.2V14.8C3.6 15.6837 4.31634 16.4 5.2 16.4H14.8C15.6837 16.4 16.4 15.6837 16.4 14.8V5.2C16.4 4.31634 15.6837 3.6 14.8 3.6ZM5.2 2C3.43269 2 2 3.43269 2 5.2V14.8C2 16.5673 3.43269 18 5.2 18H14.8C16.5673 18 18 16.5673 18 14.8V5.2C18 3.43269 16.5673 2 14.8 2H5.2Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80078 3.93127L3.93215 2.7999L16.9429 15.8107L15.8115 16.942L2.80078 3.93127Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8125 2.80005L16.9439 3.93142L3.93311 16.9422L2.80174 15.8108L15.8125 2.80005Z",
  fill: "white"
})));
export default SvgColourWhiteSize20;